export const cultureData = [
    { "key": "tr-TR", "value": "tr", "culture": "tr-TR" },
    { "key": "en-US", "value": "en", "culture": "en-US" }
];